export const getDecimalPlaces = (n: number): number => {
  const strVal = String(n);
  if (strVal.includes(".")) {
    return strVal.split(".")[1].length || 0;
  }
  return 0;
};

export const finiteOrNull = (n: number): number | null => (Number.isFinite(n) ? n : null);

/**
 * Strips binary floating-point noise from arithmetic on user-entered decimals
 * (e.g. 130.1 - 5.1 === 124.99999999999999) while preserving real precision up
 * to 9 decimal places — far beyond any realistic lab measurement.
 */
export const roundToPrecision = (n: number): number => Math.round(n * 1e9) / 1e9;
